import { request } from './request';
import * as PATHS from '@/constants/path';
import { URLParamBuilder } from '@/utils/functions';


export function fetchLeadTasksList({ query, url }: { query?: any; url?: string }) {
  const finalUrl = url || URLParamBuilder(PATHS.GET_LEAD_TASKS, {
    queryString: query,
  });
  return request(finalUrl, {
    method: 'GET',
  });
}

export function fetchSingleLeadTaskRequest({ params }: { params: { taskId: string } }) {
  const url = URLParamBuilder(PATHS.GET_LEAD_TASK_DETAILS, { params });
  return request(url, {
    method: 'GET',
  });
}

// Decides how a task is created and owned (pure — unit tested):
// - lead and no assignees  -> POST /leads/:leadId/tasks (task owned by the lead)
// - assignees (or no lead) -> POST /tasks, lead becomes related_lead_id;
//                             with no assignees the API assigns the current user
export function resolveCreateTaskEndpoint(data: Record<string, any>) {
  const assigneeIds = [
    ...(Array.isArray(data.assignee_ids) ? data.assignee_ids : []),
    ...(data.assignee_id ? [data.assignee_id] : []),
  ].filter(Boolean);

  const payload = { ...data };
  delete payload.leadId;
  delete payload.assignee_id;
  delete payload.assignee_ids;

  if (data.leadId && assigneeIds.length === 0) {
    return {
      url: URLParamBuilder(PATHS.CREATE_TASK_FOR_LEAD, {
        params: { leadId: data.leadId },
      }),
      payload,
    };
  }

  if (assigneeIds.length > 0) payload.assignee_ids = [...new Set(assigneeIds)];
  if (data.leadId) payload.related_lead_id = data.leadId;

  return {
    url: URLParamBuilder(PATHS.CREATE_LEAD_TASK),
    payload,
  };
}

export function createLeadTaskRequest({
                                        data,
                                      }) {
  const { url, payload } = resolveCreateTaskEndpoint(data);

  return request(url, {
    method: 'POST',
    data: payload,
  });
}

export function editLeadTaskRequest({
                                      data,
                                      params,
                                    }) {
  const url = URLParamBuilder(PATHS.EDIT_LEAD_TASK, { params });
  return request(url, {
    method: 'PUT',
    data,
  });
}

export function partialEditLeadTaskRequest({
                                             data,
                                             params,
                                           }) {
  const url = URLParamBuilder(PATHS.EDIT_LEAD_TASK, { params });
  return request(url, {
    method: 'PATCH',
    data,
  });
}

export function deleteLeadTaskRequest({
                                        params,
                                      }) {
  const url = URLParamBuilder(PATHS.EDIT_LEAD_TASK, { params });
  return request(url, {
    method: 'DELETE',
  });
}
